/** <input type="datetime-local"> reads/writes in the browser's LOCAL time with no
 *  timezone suffix -- these two are the only correct way to round-trip that against an
 *  epoch-ms value without silently shifting it by the viewer's UTC offset. */
export function msToLocalInputValue(ms: number): string {
  const d = new Date(ms)
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export function localInputValueToMs(value: string): number | null {
  if (!value) return null
  const ms = new Date(value).getTime()
  return Number.isFinite(ms) ? ms : null
}
